import { render, staticRenderFns } from "./ModuloTempos.vue?vue&type=template&id=acc4dea4&"
import script from "./ModuloTempos.vue?vue&type=script&lang=js&"
export * from "./ModuloTempos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports